import { Box } from '@mui/material'
import { colors } from '../../sharedComponents/src/globalHeader/theme/colors'
import * as utils from './utils'

export type EvalBarProps = {
    score: number
    mate?: boolean
    colorToMove: number
}

export const EvalBar = (props: EvalBarProps) => {
    const { score, mate, colorToMove } = props
    const whitePercentage = utils.calculateWhitePercentage(score, colorToMove, mate)
    const blackPercentage = 100 - whitePercentage

    return (
        <Box
            sx={(theme) => ({
                position: 'absolute',
                left: '-16px',
                top: '-2px',
                bottom: '-2px',
                border: `2px solid ${theme.palette.primary.light} !important`,
                borderColor: 'primary.light',
                display: 'flex',
                flexDirection: 'column',

                borderRadius: '6px',
                overflow: 'hidden',
                animation: '1s ease-in-out infinite alternate',
                margin: '0',
            })}
        >
            <Box
                style={{
                    backgroundColor: colors.darkBlue,
                    flex: `${blackPercentage} 0 0`,
                    borderBottom: `${whitePercentage === 0 ? `0.063rem solid ${colors.white}` : 'none'}`,
                    borderRadius: '0',
                    transition: 'flex 0.5s ease-in-out',
                    width: '12px',
                }}
            />
            <Box
                style={{
                    backgroundColor: 'white',
                    flex: `${whitePercentage} 0 0`,
                    borderTop: `${blackPercentage === 0 ? `0.063rem solid ${colors.white}` : 'none'}`,
                    borderRadius: '0',
                    transition: 'flex 0.5s ease-in-out',
                    width: '12px',
                }}
            />
        </Box>
    )
}
